// Get tech managers list (simple name, email, objectId for dropdown)
export function getTechnicianManagers() {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/users/tech-managers`,
    method: 'GET',
  }
}

// Get all locations with their current on-call technician managers
export function getAllLocationsWithCurrentManagers() {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/with-current-managers`,
    method: 'GET',
  }
}

// Get all on-call overrides (current and scheduled)
export function getAllOnCallOverrides() {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/on-call-overrides`,
    method: 'GET',
  }
}

export interface IOnCallOverrideData {
  technicianManagerObjectId: string
  fromDate: string
  toDate: string
}

export function setOnCallTechnicianManagerOverride(data: IOnCallOverrideData) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/set-on-call-technician-manager`,
    method: 'POST',
    body: data,
  }
}

export function updateOnCallOverride(
  overrideObjectId: string,
  data: IOnCallOverrideData,
) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/on-call-override/${overrideObjectId}`,
    method: 'PUT',
    body: data,
  }
}

export function deleteOnCallOverride(overrideObjectId: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/on-call-override/${overrideObjectId}`,
    method: 'DELETE',
  }
}

export interface ITechnicianManagerCoverageData {
  originalManagerObjectId: string
  coverageManagerObjectId: string
  fromDate: string
  toDate: string
}

export function getAllTechnicianManagerCoverages() {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/technician-manager-coverages`,
    method: 'GET',
  }
}

export function createTechnicianManagerCoverage(
  data: ITechnicianManagerCoverageData,
) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/technician-manager-coverages`,
    method: 'POST',
    body: data,
  }
}

export function deleteTechnicianManagerCoverage(coverageObjectId: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/technician-manager-coverages/${coverageObjectId}`,
    method: 'DELETE',
  }
}
